import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-external-app',
  templateUrl: './external-app.component.html',
  styleUrls: ['./external-app.component.css']
})
export class ExternalAppComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
